<!-- eslint-disable vue/valid-template-root -->
<template>
  <MDBBtn @click='onSelect' class="answer-btn">
  <MDBCard>
    <MDBCardImg
      :src="imageName"
      top
      alt="..."
      class='d-none d-sm-block'
    />
    <MDBCardBody>
      <MDBCardTitle>{{ title }}</MDBCardTitle>
      <MDBCardText v-if="lifestyle">
        {{ lifestyle }}
      </MDBCardText>
    </MDBCardBody>
  </MDBCard>
  </MDBBtn>
</template>

<script>
import { MDBCard, MDBCardImg, MDBCardBody, MDBCardTitle, MDBCardText, MDBBtn } from "mdb-vue-ui-kit";

export default {
  components: {
    MDBCard,
    MDBCardImg,
    MDBCardBody,
    MDBCardTitle,
    MDBCardText,
    MDBBtn
},
  props: {
    imageName: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '~~~~',
    },
    lifestyle: {
      type: String,
      default: '',
    },
    /* eslint-disable vue/require-default-prop */
    onSelect: {
      type: Function,
    },
    /* eslint-enable vue/require-default-prop */
  },
};
</script>
